import React from 'react';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { useFlowStep } from 'hooks/useFlowStep/useFlowStep';
import { FEELIX_THEMES, FLOW_STEP_MAPPING, SUBSCRIPTION_TYPE } from '../../constants';
import { SoloProgressBar } from './solo/SoloProgressBar';
import { ModernProgressBar } from './modern/ModernProgressBar';

export const ProgressBar: React.FC = () => {
  const { theme, subscriptionType } = useSessionContext();
  const flowStep = useFlowStep();
  const totalSteps = FLOW_STEP_MAPPING[subscriptionType]?.length ?? -1;
  if (flowStep === -1 || subscriptionType === SUBSCRIPTION_TYPE.TRIAL) return null;
  const Component = theme === FEELIX_THEMES.SOLO ? SoloProgressBar : ModernProgressBar;

  return (
    <Component
      activeStep={flowStep + 1} // flow step is 0 based
      totalSteps={totalSteps}
    />
  );
};
